import { render, staticRenderFns } from "./team-member.vue?vue&type=template&id=547315da&"
import script from "./team-member.vue?vue&type=script&lang=js&"
export * from "./team-member.vue?vue&type=script&lang=js&"
import style0 from "./team-member.vue?vue&type=style&index=0&id=547315da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports